import {RolesEnum} from '../enums/Roles.enum';

/**
 * Maps a roles claim to an array of RolesEnum values. Accepts either form the
 * token can produce:
 *  - a comma-separated string (B2C raw token extension_Roles, e.g. "Super Admin, USA Admin")
 *  - an array of role strings (JASA IdentityServer OIDC 'role' claim, multi-valued)
 * A single-value 'role' claim arrives as a plain string and is handled by the string path.
 * @param b2cRoles - The roles claim (string or string[])
 * @returns Array of RolesEnum values
 */
export function mapB2CRoles(b2cRoles: string | string[]): RolesEnum[] {
  if (!b2cRoles || (Array.isArray(b2cRoles) && b2cRoles.length === 0)) return [];
  const roleList = Array.isArray(b2cRoles) ? b2cRoles : b2cRoles.split(',');
  return roleList
    .map((role) => role.trim())
    .map((role) => {
      // Normalize spaces and case for mapping
      switch (role.replace(/\s+/g, '').toLowerCase()) {
        case 'superadmin':
          return RolesEnum.SuperAdmin;
        case 'usaadmin':
          return RolesEnum.USAAdmin;
        case 'areaadmin':
          return RolesEnum.AreaAdmin;
        case 'staff':
          return RolesEnum.Staff;
        case 'educator':
          return RolesEnum.Educator;
        case 'volunteer':
          return RolesEnum.Volunteer;
        case 'student':
          return RolesEnum.Student;
        case 'all':
          return RolesEnum.All;
        default:
          return undefined;
      }
    })
    .filter((role): role is RolesEnum => role !== undefined);
}
